import { Link } from "react-router-dom";
import User from "../interfaces/user";
import { ASSETS_URL } from "../util/constants";

interface UserListItemProps {
  user: User;
  rank: number;
}

const UserListItem = ({ user, rank }: UserListItemProps) => {
  const defaultAvatar = `${ASSETS_URL}/avatar/collector.png`;

  return (
    <Link
      to={`/profile/${user.username}`}
      key={user.id}
      className="preview-entry"
    >
      <div
        className={`team-decal ${
          user.pokemonGoProfile?.team.name.toLowerCase() || "harmony"
        }`}
      ></div>
      <span className="rank">#{rank}</span>
      <img
        src={user.pokemonGoProfile?.urlImage || defaultAvatar}
        alt="Player Avatar"
        className="avatar"
      />
      <div className="player-info">
        <span className="player-name">{user.username}</span>
        <div className="player-details">
          <span className="player-level">
            Level {user.pokemonGoProfile?.level || "N/A"}
          </span>
          <img
            src={`/assets/${user.country?.pathImage}`}
            alt={user.country?.name}
            className="country-flag"
          />
        </div>
      </div>
      <div className="player-stats">
        <span className="xp">
          {(user.pokemonGoProfile?.xp || 0).toLocaleString()} XP
        </span>
        <span className="medals">{user.pokemonGoProfile?.medalCount || "--"} Medals {/* Placeholder adicionado */}</span>
      </div>
    </Link>
  );
};

export default UserListItem;
